<script setup>
import Button from "@/Components/Button.vue";
import Select from "@/Components/Select.vue";
import Textarea from "@/Components/Textarea.vue";
import Navbar from "@/Components/Navbar.vue";
import Label from "@/Components/Settings/Label.vue";
import Input from "@/Components/Settings/Input.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, onMounted, watch } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

import { Inertia } from "@inertiajs/inertia";

const form = useForm({});

const patientResults = ref([]);

const showErrModal = ref(false);
const errMessage = ref("");

const patientNumber = ref("");

const props = defineProps({
  errors: Object,
  type: String,
});
</script>

<template>
  <div
    id="theme-wrapper"
    style="background-image: url('/storage/img/auth_bg.jpg')"
    class="bg-cover bg-no-repeat flex h-screen bg-oteoBlue-600"
    :class="'theme-' + $page.props.theme ?? 'spitta'"
  >
    <Head title="Suchen" />
    <Navbar class="navbar-sub w-full" />
    <div class="bg-white w-full max-w-8xl m-auto rounded-xl">
      <header
        class="
          bg-gray-100
          flex
          justify-between
          items-center
          px-12
          py-8
          rounded-tl-xl rounded-tr-xl
          relative
        "
      >
        <div class="flex">
          <Link href="/termin-suchen">
            <h2
              class="text-3xl py-3 mr-8"
              :class="{
                'font-semibold': props.type === 'slot',
                'font-light opacity-40': props.type !== 'slot',
              }"
            >
              Freie Termine
            </h2>
          </Link>
          <Link href="/termin-finden">
            <h2
              class="text-3xl py-3"
              :class="{
                'font-semibold': props.type === 'patient',
                'font-light opacity-40': props.type !== 'patient',
              }"
            >
              Patiententermine
            </h2>
          </Link>
        </div>

        <div
          class="w-16 overflow-hidden inline-block absolute bottom-0"
          :class="{
            'left-28': props.type === 'slot',
            'left-[23rem]': props.type === 'patient',
          }"
        >
          <div
            class="h-8 w-11 bg-white rotate-45 transform origin-bottom-left"
          ></div>
        </div>

        <div class="flex relative">
          <HeaderLink class="mr-3" href="/" type="close">Schließen</HeaderLink>
        </div>
      </header>
      <div class="flex p-12 relative">
        <slot />
      </div>
    </div>
  </div>
</template>
